module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-72x72-c60bdfb997a008292ba5895f2bc4e591.png";